import { useFormik } from 'formik';
import * as Yup from 'yup';

export function useCloseValidation(onSubmit) {
  const initialValues = {
    date: '',
    comment: '',
  };

  const formik = useFormik({
    initialValues,
    validationSchema: Yup.object({
      date: Yup.date()
        .required('El campo fecha es requerido')
        .max(new Date(), 'La fecha no puede ser mayor a hoy'),
      comment: Yup.string().required('El campo comentario es requerido'),
    }),
    validateOnBlur: true,
    validateOnChange: true,
    onSubmit,
  });

  return formik;
}
